import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/** The site / starting node the field user operates from. Persisted so it survives reloads. */
export interface SiteLocation {
	id: string;
	name: string;
	/**
	 * The NAV erp station code (e.g. "105"). Populated by `useStartingSites`; optional so persisted
	 * selections from before this field existed, and FINISH/MATERIAL call sites that only ever needed
	 * id/name, still satisfy the type. The Retail slice uses it to resolve route-keyed BP-lot queries
	 * (`stationBpLotInventory` / `retailAvailableBpLots` are keyed by NAV route code, not this site's
	 * GUID `id`).
	 */
	erpId?: string;
}

export interface SiteState {
	location: SiteLocation | null;
	/** Whether the current route requires a selected site (RequireSite toggles this). */
	required: boolean;
}

const initialState: SiteState = {
	location: null,
	required: true
};

const siteSlice = createSlice({
	name: "site",
	initialState,
	reducers: {
		updateSite: (state, action: PayloadAction<SiteLocation | null>) => {
			state.location = action.payload;
		},
		updateSiteRequired: (state, action: PayloadAction<boolean>) => {
			state.required = action.payload;
		}
	}
});

export const { updateSite, updateSiteRequired } = siteSlice.actions;
export default siteSlice.reducer;
